import { theme } from '@acorns/grove'
import styled from 'styled-components'

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    padding: 0;
    width: 220px;
  }
`

export const Separator = styled.div`
  border-bottom: 1px solid ${theme.colors.primaryIvoryLight};

  @media (max-width: ${theme.dimensions.breakpointsSmall}px) {
    display: none;
  }
`

export const FooterTextContainer = styled.div`
  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    max-width: 340px;
  }
`

export const Link = styled.a`
  text-decoration: underline;
  color: ${theme.colors.primaryStone};
  cursor: pointer;
`

export const Code = styled.span`
  color: ${theme.colors.primaryStone};
`
